import Home from '../Components/Home';
import Faqs from '../Components/faq';
import TermsConditions from '../Components/TermsConditions';
import AboutUs from '../Components/AboutUs';
import Impressum from '../Components/Impressum';
import Policy from '../Components/Policy';
import ContactUs from '../Components/ContactUs';
import Blogs from '../Components/blogs';

import BlogDetails from '../Components/blogs/blogDetails';
import Ingredients from '../Components/ingredients';
import IngredientsDetails from '../Components/ingredients/IngredientDetails';
import Partner from '../Components/Partner';

import Checkout from '../Components/Checkout';

import Quiz from '../Components/Quiz';

import Dashboard from '../Components/Customer/Dashboard';
import Customer from '../Components/Customer/Customer';
import ProductSuggestion from '../Components/Customer/ProductSuggestion';
import React from 'react';
import CustomFormula from '../Components/Customer/CustomFormula';
import CustomFormulaSuccess from '../Components/Customer/CustomFormulaSuccess';
import CustomQuizSuccess from '../Components/Quiz/CustomQuizSuccess';
import NotFound from '../Components/NotFound';
import Energy from '../Components/FocusAreas/Energy';
import Focus from '../Components/FocusAreas/Focus';
import Sleep from '../Components/FocusAreas/Sleep';
import SportsPerformance from '../Components/FocusAreas/SportsPerformance';
import Stress from '../Components/FocusAreas/Stress';
import Mood from '../Components/FocusAreas/Mood';
import ImmuneSystem from '../Components/FocusAreas/ImmuneSystem';
import Refill from '../Components/Refill';
import MysteryCredit from '../Components/MysteryCredit';
import Product from '../Components/Products/Product';
import Products from '../Components/Products/Products';
import Practitioner from '../Components/Practitioner';
import Omega3Page from '../Components/Omega3/Omega3Page';
import Omega3AddonPage from '../Components/Omega3/Omega3AddonPage';
import BlackFridayLeadGen from '../Components/pages/BlackFriday';
import BlackFridayThankYou from '../Components/pages/BlackFriday/ThankYou';
import AddToRoutine from '../Components/pages/AddToRoutine';
import QrAddSticker from '../Components/pages/AddToRoutine/QrAddSticker';
import HowToTake from '../Components/HowToTake/HowToTake';
import ClassmedResult from '../Components/Classmed/ClassmedResult';
import ClassmedOrderSuccess from '../Components/Classmed/ClassmedOrderSuccess';

// export const routes = [
//     { path: `${process.env.PUBLIC_URL}/`, Component: <Home /> },
//     { path: `${process.env.PUBLIC_URL}/faqs`, Component: <Faqs /> },
//     { path: `${process.env.PUBLIC_URL}/legal`, Component: <TermsConditions /> },
//     { path: `${process.env.PUBLIC_URL}/about`, Component: <AboutUs /> },
//     { path: `${process.env.PUBLIC_URL}/impressum`, Component: <Impressum /> },
//     { path: `${process.env.PUBLIC_URL}/policy`, Component: <Policy /> },
//     { path: `${process.env.PUBLIC_URL}/contactus`, Component: <ContactUs /> },
//     { path: `${process.env.PUBLIC_URL}/blogs`, Component: <Blogs /> },
//     { path: `${process.env.PUBLIC_URL}/blogs/:slug`, Component: <BlogDetails /> },
//     { path: `${process.env.PUBLIC_URL}/checkout`, Component: <Checkout /> },
//
// ]

export const routes = [
  { path: `/faqs`, Component: <Faqs /> },
  { path: `/legal`, Component: <TermsConditions /> },
  { path: `/about`, Component: <AboutUs /> },
  { path: `/impressum`, Component: <Impressum /> },
  { path: `/policy`, Component: <Policy /> },
  { path: `/contactus`, Component: <ContactUs /> },
  { path: `/blogs`, Component: <Blogs /> },
  { path: `/blogs/:slug`, Component: <BlogDetails /> },

  { path: `/ingredients`, Component: <Ingredients /> },
  { path: `/ingredients/:slug`, Component: <IngredientsDetails /> },

  { path: `/checkout`, Component: <Checkout /> },
  { path: `/practitioners`, Component: <Practitioner /> },

  { path: `/partner`, Component: <Partner /> },
  { path: `/for-your-energy`, Component: <Energy /> },
  { path: `/for-your-focus`, Component: <Focus /> },
  { path: `/for-your-sleep`, Component: <Sleep /> },
  { path: `/for-your-stress`, Component: <Stress /> },
  { path: `/for-your-mood`, Component: <Mood /> },
  { path: `/for-your-immune-system`, Component: <ImmuneSystem /> },
  { path: `/for-your-sport-performance`, Component: <SportsPerformance /> },
  { path: `/refill`, Component: <Refill /> },
  { path: `/mystery-credit`, Component: <MysteryCredit /> },
  { path: `/products`, Component: <Products /> },
  { path: `/*`, Component: <NotFound /> },
];

// export const quizRoutes = [
//     { path: `${process.env.PUBLIC_URL}/quiz`, Component: <Quiz /> },
// ];

export const quizRoutes = [
  { path: `/quiz`, Component: <Quiz /> },
  { path: `/black-friday`, Component: <BlackFridayLeadGen /> },
  { path: `/black-friday/thank-you`, Component: <BlackFridayThankYou /> },
  { path: `/add`, Component: <AddToRoutine /> },
  { path: `/qr-addsticker`, Component: <QrAddSticker /> },
  { path: `/classmed/quiz`, Component: <Quiz /> },
  { path: `/classmed/result`, Component: <ClassmedResult /> },
  { path: `/classmed/order-success`, Component: <ClassmedOrderSuccess /> },
  { path: `/custom-quiz`, Component: <Quiz /> },
  { path: `/custom-quiz-success`, Component: <CustomQuizSuccess /> },
  { path: `/product-suggestion`, Component: <ProductSuggestion /> },
  { path: `/custom-formula`, Component: <CustomFormula /> },
  { path: `/custom-formula/success`, Component: <CustomFormulaSuccess /> },
  { path: `/products/omega-3/addon`, Component: <Omega3AddonPage /> },
  { path: `/products/omega-3`, Component: <Omega3Page /> },
  { path: `/products/:slug`, Component: <Product /> },
];

// export const customerRoutes = [
//     { path: `${process.env.PUBLIC_URL}/customer`, Component: <Customer /> },
//     { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard /> },
// ];

export const customerRoutes = [
  { path: `/customer`, Component: <Customer /> },
  { path: `/dashboard`, Component: <Dashboard /> },
];
